import type { ShortcutIcon } from "../shortcuts";
import { APP_PAGES } from "./app-pages";
import { CMS_ADVANCED_PAGES } from "./cms-advanced-pages";
import { CMS_PAGES } from "./cms-pages";
import type { BoPage } from "./model";

export { BO_PAGE_SECTIONS, type BoPage, type BoPageSection } from "./model";

/** Toutes les pages proposables, chacune rangée dans sa rubrique. */
export const BO_PAGES: BoPage[] = [
  ...APP_PAGES,
  ...CMS_PAGES,
  ...CMS_ADVANCED_PAGES,
];

/** Icône d'un lien personnalisé : celle de la page visée, sinon un lien. */
export function iconForPath(path: string): ShortcutIcon {
  const pathname = path.split(/[?#]/)[0];
  return (
    BO_PAGES.find((p) => p.path.split("?")[0] === pathname)?.icon ?? "link"
  );
}
